/*
 * uploadWidgetModule
 * */

import uploadWidgetComponent from './uploadWidget.component';
import uploadWidgetTableModule from './uploadWidgetTable/index';

const uploadWidgetModule = angular.module('app.components.dashboard.uploadWidget', [uploadWidgetTableModule])
	.component('uploadWidget', uploadWidgetComponent)
	.name;

export default uploadWidgetModule;
